<script setup lang="ts">
import Button from '@/core/components/base/Button.vue'
import { useButtonScrolldown, useButtonScrolldownMock } from './ButtonScrolldown'

const { disabled, doScrollDown } = useButtonScrolldown()

function handleTap(event: PointerEvent) {
  doScrollDown()
}
</script>

<template>
  <Button class="button-scrolldown" :disabled @tap="handleTap">
    <template #default><img src="/images/simakatra/arrow-down.gif" /></template>
    <template #disabled><img src="/images/simakatra/arrow-down-disable.png" /></template>
  </Button>
</template>

<style scoped>
.button-scrolldown {
  position: absolute;
  top: 564px;
  left: 653px;
}
</style>
